import { useEffect, useRef, useState, useCallback } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { showToast } from "redux/slices/Toasts";
import { RootState } from "redux/store";
import useToggle from "hooks/useToggle";
import { cleanCatalogueDetails } from "redux/slices/Catalogues";
import { StockPopup } from "./Popups/StocksPopup";
import { cleanDispensePricingDetails, deleteDispensePricing, getDispensePricing, updateDispensePricing, updateDispensePricingField } from "redux/slices/DispensePricing";
import { FormatDateToDMY, displayFloatPrice } from "helpers/data/dataHandling";
import { CustomDropDown, Spinner, Table, Title, CommonColumnProperties, CustomColumns, ImportWizard, Modal, FormatType, TableRef } from "components";
import { ValidationState } from "components/ImportWizard/ImportWizardTypes";
import { getStores } from "redux/slices/Stores";
import { SystemStocksPopup } from "popups/SystemStocks/SystemStocks";
import { ParseDate } from "helpers/data/CommonImport";
import { runBatchWorkers } from "components/WebWorkers/ZWebWorker";
import { DispensePricingImportWorkerData, DispensePricingImportWorkerResponseData } from "./dispensePricingImportWorker";
import { DispensePricingUpdateQtyType } from "models/functionModels/dispensePricing/DispensePricingUpdateFunction";
import { InternalResponse, ServerResponse } from "models/common/responseObjects";
import { onlyUnique } from "helpers/Functions";

export function DispensePricingList() {
	const form = useRef(null);
	const dispatch = useAppDispatch();
	const deletedIds = useRef<string[]>([]);
	const { dispensePricingId } = useParams();
	const [isValidated, setValidated] = useToggle();
	const [newStockList, setNewStockList] = useState<any[]>([]);
	const [showMenu, setShowMenu] = useState<boolean>(false);
	const stores = useAppSelector((state: RootState) => state.stores);
	const products = useAppSelector((state: RootState) => state.products);
	const [importPercentage, setImportPercentage] = useState<number>(0);
	const [isNewDispensePricing, setIsNewDispensePricing] = useState<boolean>(true);
	const dispensePricing = useAppSelector((state: RootState) => state.dispensePricing);
	const [clearAllExistingPricing, setClearAllExistingPricing] = useState<boolean>(false);
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
	const [showWarning, setShowWarning] = useState<boolean>(false);
	const user = useAppSelector((state: RootState) => state.logedinUser);

	const columns = [
		{
			Header: "Name",
			accessor: "name",
			defaultCanSort: true,
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{row.value}</Link> : <>{row.value}</>,

		},
		{
			Header: "Private Price",
			accessor: "privateFixedPrice",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{displayFloatPrice(row.value)}</Link> : <>{displayFloatPrice(row.value)}</>,
		},
		{
			Header: "Qty",
			accessor: "privateFixedPricePacks",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{row.value ? row.value : ""}</Link> : <>{row.value ? row.value : ""}</>,
		},
		{
			Header: "Start Date",
			accessor: "privateFixedPriceStart",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{FormatDateToDMY(row.value)}</Link> : <>{FormatDateToDMY(row.value)}</>,
		},
		{
			Header: "End Date",
			accessor: "privateFixedPriceEnd",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{FormatDateToDMY(row.value)}</Link> : <>{FormatDateToDMY(row.value)}</>,
		},
		{
			Header: "PBS Price",
			accessor: "pbsFixedPrice",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{displayFloatPrice(row.value)}</Link> : <>{displayFloatPrice(row.value)}</>,
		},
		{
			Header: "Qty",
			accessor: "pbsFixedPricePacks",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{row.value ? row.value : ""}</Link> : <>{row.value ? row.value : ""}</>,
		},
		{
			Header: "Start Date",
			accessor: "pbsFixedPriceStart",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{FormatDateToDMY(row.value)}</Link> : <>{FormatDateToDMY(row.value)}</>,
		},
		{
			Header: "End Date",
			accessor: "pbsFixedPriceEnd",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{FormatDateToDMY(row.value)}</Link> : <>{FormatDateToDMY(row.value)}</>,
		},
		{
			Header: "Club Price",
			accessor: "clubFixedPrice",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{displayFloatPrice(row.value)}</Link> : <>{displayFloatPrice(row.value)}</>,
		},
		{
			Header: "Qty",
			accessor: "clubFixedPricePacks",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{row.value ? row.value : ""}</Link> : <>{row.value ? row.value : ""}</>,
		},
		{
			Header: "Start Date",
			accessor: "clubFixedPriceStart",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{FormatDateToDMY(row.value)}</Link> : <>{FormatDateToDMY(row.value)}</>,
		},
		{
			Header: "End Date",
			accessor: "clubFixedPriceEnd",
			Cell: (row: any) => user.permissions.dispensePricing.canUpdate ? <Link to={"#"} onClick={() => handleStockClick(row.cell.row.original.productsSpecialPricingID)}>{FormatDateToDMY(row.value)}</Link> : <>{FormatDateToDMY(row.value)}</>,
		}
	];

	useEffect(() => {
		if (dispensePricingId != null) {
			dispatch(getStores({ storeGroupIds: [currentStoreGroupId] }));
			setStoresDropdown();
			dispatch(getDispensePricing({stores: [parseInt(dispensePricingId)] }));
			handleChange("storeId", parseInt(dispensePricingId));
			handleChange("stores", [parseInt(dispensePricingId)]);
			setIsNewDispensePricing(false);
		} else {
			dispatch(cleanDispensePricingDetails());
			setIsNewDispensePricing(true);
		}
		deletedIds.current = [];
	}, [dispensePricingId]);

	useEffect(() => {
		handleChange("clearAllExistingPricing", clearAllExistingPricing);
	}, [clearAllExistingPricing]);

	useEffect(() => {
		setStoresDropdown();
	}, [stores.table]);

	useEffect(() => {
		console.log("Table has been set to: ", dispensePricing.table);
	}, [dispensePricing.table])

	function handleStockClick(stockId: any) {
		let currentStockId = dispensePricing.table.findIndex((item: any) => item.productsSpecialPricingID === stockId);
		handleChange("stockIndex", currentStockId);
		handleChange("stockPopup", true);
	}

	function handleSubmit() {
		handleChange("loading", true);
		setShowWarning(false);

		//Manage deleted Ids
		if (deletedIds.current.length > 0) {
			dispatch(deleteDispensePricing({
				clearAllExistingPricing: false,
				deletedProductsSpecialPricingIds: deletedIds.current,
				stores: dispensePricing.stores
			}))
		}

		// @ts-ignore
		if (form.current.checkValidity() === true) {
			if (isNewDispensePricing) {
				// dispatch(createDispansePricing(dispensePricing)).then((res) => handleUpdate(res));
			} else {				
				const selectedStocks: any[] = [];
				dispensePricing.selectedStocks.forEach((stck: number) => {
					selectedStocks.push(dispensePricing.table[stck]);
				});

				dispatch(updateDispensePricing({...dispensePricing, updates: selectedStocks, packQtyType: DispensePricingUpdateQtyType.Tablet, stores: dispensePricing.stores})).then((res) => handleUpdate(res));
			}
		} else {
			handleChange("loading", false);
		}

		deletedIds.current = [];

		setValidated();
	}

	function handleUpdate(res: ServerResponse<InternalResponse<boolean>>) {
		var errors = res.stores.filter((i) => i.response.error !== null).map((i) => i.response.error)
		if (errors.length === 0) { //no error!
			// setTimeout(() => {
			// 	navigate("/app/dispense-pricing");
			// }, 500);

			deletedIds.current = []; 
			dispensePricingId != null && dispatch(getDispensePricing({ stores: [parseInt(dispensePricingId)] }));

		} else {
			dispatch(showToast({ value: errors }));
		}
		handleChange("loading", false);
	}

	function handleDelete() {
		const lines = [...dispensePricing.table];
		const selectedStocksId: any = [];
		dispensePricing.selectedStocks.forEach((item: any) => {
			// @ts-ignore
			selectedStocksId.push(lines[item].productID);
			// @ts-ignore
			deletedIds.current.push(lines[item].productsSpecialPricingID);
		});
		selectedStocksId.forEach((item: any) => {
			let currentStockId = lines.findIndex((e: any) => e.productID === item);
			lines.splice(currentStockId, 1);
		});
		handleChange("table", lines);
	}

	function handleChange(option: any, optionValue: any) {
		dispatch(updateDispensePricingField({ key: option, value: optionValue }));
	}

	const selectedStocks = useCallback((pageIndex: any) => {
    	//addSelectedRows
		handleChange("selectedStocks", pageIndex);
	}, []);

	function clearAllSpecialPrices() {
		const newTable: any = [];
		dispensePricing.table.forEach((item: any) => {
			const stock = { ...item };
			stock.privateFixedPrice = 0;
			newTable.push(stock);
		});
		handleChange("table", newTable);
	}

	function setPrivatePriceToPbsPrice() {
		const newTable: any = [];
		dispensePricing.table.forEach((item: any) => {
			const stock = { ...item };
			stock.pbsFixedPrice = stock.privateFixedPrice;
			stock.pbsFixedPricePacks = stock.privateFixedPricePacks;
			newTable.push(stock);
		});
		handleChange("table", newTable);
	}

	function setPrivatePriceToClubPrice() {
		const newTable: any = [];
		dispensePricing.table.forEach((item: any) => {
			const stock = { ...item };
			stock.clubFixedPrice = stock.privateFixedPrice;
			stock.clubFixedPricePacks = stock.privateFixedPricePacks;
			newTable.push(stock);
		});
		handleChange("table", newTable);
	}

	function setStoresDropdown() {
		let stockGroupsDropdown: any[] = [];
		stores.table.forEach((item: any) => {
			//@ts-ignore
			stockGroupsDropdown.push({ id: item.id, label: item.name, checked: dispensePricing.stores.includes(item.id) ? true : false });
		});
		handleChange("stockGroupsDropdown", stockGroupsDropdown);
	}

	function handleCheckedDropdown(key: number, label: string, value: any) {
		let storesGroupsDropdown: any[] = [];
		storesGroupsDropdown.push(...dispensePricing.stockGroupsDropdown);
		let index = storesGroupsDropdown.findIndex((item) => item.id === key);
		storesGroupsDropdown[index] = { id: key, label: label, checked: value };
		let selectedStockGroups: any[] = [];
		storesGroupsDropdown.forEach((item: any) => {
			if (item.checked) selectedStockGroups.push(item.id);
		});
		dispatch(updateDispensePricingField({ key: "stockGroupsDropdown", value: storesGroupsDropdown }));
		dispatch(updateDispensePricingField({ key: "stores", value: selectedStockGroups }));
	}

	const TopbarChild = () => {
		return user.permissions.dispensePricing.canUpdate ?
			<CustomDropDown
				items={dispensePricing.stockGroupsDropdown}
				handleChecked={handleCheckedDropdown}
				displayDropdown={showMenu}
				setDisplayDropdown={setShowMenu}
				className="cutom-table-checkbox-dropdown d-inline-flex me-1"
				placeholder="Share Prices"
				selectedPlaceholder="Share Prices"
				
			/> : <></>;
	};




	//Section for the wizard

	function PriceValidation(value: any, type: string): { valid: boolean, error: string, newValue?: any } {

		//If empty, then we assume its fine
		if (value === undefined || value === null || value === 0) {
			return { valid: true, error: "", newValue: null }
		}

		let parsed = parseFloat(value);
		if (Number.isNaN(parsed)) {
			return { valid: false, error: `Invalid ${type} Price` }
		}
		else {
			return { valid: true, error: "", newValue: parseFloat(parsed.toFixed(2)) }
		}
	}

	function QtyValidation(value: any, type: string): { valid: boolean, error: string, newValue?: any } {

		//If empty, then we assume its fine
		if (value === undefined || value === null || value === 0) {
			return { valid: true, error: "", newValue: null }
		}

		let parsed = parseInt(value);
		if (Number.isNaN(parsed)) {
			return { valid: false, error: `Invalid ${type} Qty` }
		}
		else {
			return { valid: true, error: "", newValue: parsed }
		}
	}

	function DateValidation(value: any, type: string, fileType: FormatType = 'csv'): { valid: boolean, error: string, newValue?: any } {

		if (value === undefined || value === null) {
			return { valid: true, error: "", newValue: null }
		}

		const dateParts = value.toString().split(/\/| /); //Split by / and space
		if (dateParts.length > 2) { // dd/MM/yyyy at least
			let day = parseInt(dateParts[fileType === 'csv' ? 0 : 1]);
			let month = parseInt(dateParts[fileType === 'csv' ? 1 : 0]);
			let year = parseInt(dateParts[2]);

			if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
				return { valid: false, error: `Invalid ${type} Date Format` }
			}
			
			if (year < 100) year += 2000; //Only add if we have 2 digits
			const newDate = (day < 10 ? "0" + day : day) + "/" + (month < 10 ? "0" + month : month) + "/" + year;
			const newDatCheck = (month < 10 ? "0" + month : month) + "/" + (day < 10 ? "0" + day : day) + "/" + year;
			const date = new Date(newDatCheck);

			if (date.getDate() !== day || (date.getMonth() + 1) !== month || date.getFullYear() !== year){
				return { valid: false, error: "Invalid date format. Should be dd/MM/yyyy for csv or MM/dd/yyyy for excel import" };
			}

			return { valid: true, error: "", newValue: newDate };
		}

		return { valid: false, error: `Invalid ${type} Date Format` }
	}

	const importWizardExtraMatches: CustomColumns[] = [
		{
			title: "PrivatePrice",
			key: "PrivatePrice",
			required: true,
			display: false,
			defaultColumn: 1,
			validation: (value: any) => PriceValidation(value, "Private"),
		},
		{
			title: "PrivateQty",
			key: "PrivateQty",
			required: true,
			display: false,
			defaultColumn: 2,
			validation: (value: any) => QtyValidation(value, "Private"),
		},
		{
			title: "PrivateDateStart",
			key: "PrivateDateStart",
			required: true,
			display: false,
			defaultColumn: 3,
			validation: (value: any, formatType) => DateValidation(value, "Private", formatType),
		},
		{
			title: "PrivateDateEnd",
			key: "PrivateDateEnd",
			required: true,
			display: false,
			defaultColumn: 4,
			validation: (value: any, formatType) => DateValidation(value, "Private", formatType),
		},

		{
			title: "PbsPrice",
			key: "PbsPrice",
			required: true,
			display: false,
			defaultColumn: 5,
			validation: (value: any) => PriceValidation(value, "PBS"),
		},
		{
			title: "PbsQty",
			key: "PbsQty",
			required: true,
			display: false,
			defaultColumn: 6,
			validation: (value: any) => QtyValidation(value, "PBS"),
		},
		{
			title: "PbsDateStart",
			key: "PbsDateStart",
			required: true,
			display: false,
			defaultColumn: 7,
			validation: (value: any, formatType) => DateValidation(value, "Private", formatType),
		},
		{
			title: "PbsDateEnd",
			key: "PbsDateEnd",
			required: true,
			display: false,
			defaultColumn: 8,
			validation: (value: any, formatType) => DateValidation(value, "Private", formatType),
		},
		{
			title: "ClubPrice",
			key: "ClubPrice",
			required: true,
			display: false,
			defaultColumn: 9,
			validation: (value: any) => PriceValidation(value, "Club"),
		},
		{
			title: "ClubQty",
			key: "ClubQty",
			required: true,
			display: false,
			defaultColumn: 10,
			validation: (value: any) => QtyValidation(value, "Club"),
		},
		{
			title: "ClubDateStart",
			key: "ClubDateStart",
			required: true,
			display: false,
			defaultColumn: 11,
			validation: (value: any, formatType) => DateValidation(value, "Private", formatType),
		},
		{
			title: "ClubDateEnd",
			key: "ClubDateEnd",
			required: true,
			display: false,
			defaultColumn: 12,
			validation: (value: any, formatType) => DateValidation(value, "Private", formatType),
		},

	]
	
	const terminateWorkersRef = useRef<Function>();

	async function importStock(rows: any[]) {
		const webWorkerData: DispensePricingImportWorkerData = {
			data: rows
		};

		const errors: Map<string, string> = new Map<string, string>();

		const { runWorkers, terminateWorkers } = runBatchWorkers<DispensePricingImportWorkerData, any, DispensePricingImportWorkerResponseData>({
			workerData: webWorkerData,
			createWorker: () => new Worker(new URL('./dispensePricingImportWorker.ts', import.meta.url), { type: "module" }), 
			onWorkerResponse: (async (event, responseContext, httpErrors, reject) => {
				if (!responseContext.response.data) {
					if (httpErrors) {
						const combinedError = httpErrors.join(", ");
						// Now using this combined error, construct a { stockName, error } object for each stock and push it onto the errors array
						responseContext.originalBatchData.forEach((r: any) => {
							const errorEntry = errors.get(r.__name);
							errors.set(r.__name ?? "", errorEntry ? errorEntry + ", " + combinedError : combinedError);
						});
					}
				} else {
					setNewStockList(prev => {
						handleChange("table", [...prev, ...responseContext.response.data!.updatedStocks]);
						return [...prev, ...responseContext.response.data!.updatedStocks];
					});
				}

				setImportPercentage((prev) => Math.min(100, prev + ((1 / responseContext.numBatches) * 100)));
			}),
			onWorkersFinished: async (_) => setImportPercentage(0), 
			onWorkerError: (error, unprocessedData) => {
				unprocessedData.forEach(data => {
					const errorEntry = errors.get(data.__name);
					const errorMessage = error.message ?? "Unknown error occurred";
					errors.set(data.__name ?? "", errorEntry ? errorEntry + ", " + errorMessage : errorMessage);
				})
			}
		});

		terminateWorkersRef.current = terminateWorkers;

		await runWorkers;

		const returnErrors: { stockName: string, error: string }[] = [];

		errors.forEach((value: string, key: string) => {
			returnErrors.push({
				stockName: key,
				error: value,
			})
		});

		return [...returnErrors];
	}

	function WholeTableValidation(rows: CommonColumnProperties[]): CommonColumnProperties[] {
		let temp: CommonColumnProperties[] = [...rows];

		rows.forEach(row => {
			if (row.hasError === undefined || row.hasError === false) { //don"t bother validating bad rows
				var reasons:string[] = [];

				//Validate each section
				if (row.PrivatePrice !== null && row.PrivateQty !== null && (row.PrivatePrice <= 0 || row.PrivateQty <= 0)) reasons.push("Private price/quantity invalid");
				if (row.PbsPrice !== null && row.PbsQty !== null && (row.PbsPrice <= 0 || row.PbsQty <= 0)) reasons.push("PBS price/quantity invalid");
				if (row.ClubPrice !== null && row.ClubQty !== null && (row.ClubPrice <= 0 || row.ClubQty <= 0)) reasons.push("Club price/quantity invalid");
				
				if ((row.PrivatePrice === null && row.PrivateQty !== null) || (row.PrivatePrice !== null && row.PrivateQty === null)) reasons.push("Private price/quantity invalid");
                if ((row.PbsPrice === null && row.PbsQty !== null) || (row.PbsPrice !== null && row.PbsQty === null)) reasons.push("PBS price/quantity invalid");
                if ((row.ClubPrice === null && row.ClubQty !== null) || (row.ClubPrice !== null && row.ClubQty === null)) reasons.push("Club price/quantity invalid");

				if (row.PrivatePrice ===  null && row.PrivateQty === null && 
					row.PbsPrice === null && row.PbsQty === null && 
					row.ClubPrice === null && row.ClubQty === null) reasons.push("No prices or quantites are set");

				//Validate dates
				let privateStart = ParseDate(row.PrivateDateStart);
				let privateEnd = ParseDate(row.PrivateDateEnd);
				if (privateStart !== null && privateEnd !== null && 
					privateEnd < privateStart) reasons.push("Private end date is before start date");

				let pbsStart = ParseDate(row.PbsDateStart);
				let pbsEnd = ParseDate(row.PbsDateEnd);
				if (pbsStart !== null && pbsEnd !== null && 
					pbsEnd < pbsStart) reasons.push("PBS end date is before start date");

				let clubStart = ParseDate(row.ClubDateStart);
				let clubEnd = ParseDate(row.ClubDateEnd);
				if (clubStart !== null && clubEnd !== null && 
					clubEnd < clubStart) reasons.push("Club end date is before start date");
				
				row.hasError = reasons.length > 0;
				row.validationState = row.hasError ? ValidationState.Invalid : ValidationState.Valid;
				if (reasons.length > 0)
					row.message = reasons.join(", ");
			}
		});

		return temp;
	}

	function systemStocksPopupSave() {
		let selectedMasterProducts: any[] = [];
		let currentStock: any[] = [...dispensePricing.table];

		let selectedProducts: any[] = [];
		products.selectedRows.forEach((rowPage: any) => {
			rowPage.forEach((row: any) => {
				selectedProducts.push(row.id);
			});
		});
		// This function will have to be updated before uncommenting
		// dispatch(getProducts({ ids: selectedProducts })).then((res) => {
		// 	res.payload.data.forEach((product) => {
		// 		if (selectedProducts.includes(product.id)) {
		// 			selectedMasterProducts.push(
		// 				{
		// 					name: product.name,
		// 					productID: product.stockId,
		// 					privateFixedPrice: 0,
		// 					privateFixedPricePacks: 0,
		// 					privateFixedPriceStart: null,
		// 					privateFixedPriceEnd: null,
		// 					pbsFixedPrice: 0,
		// 					pbsFixedPricePacks: 0,
		// 					pbsFixedPriceStart: null,
		// 					pbsFixedPriceEnd: null,
		// 					clubFixedPrice: 0,
		// 					clubFixedPricePacks: 0,
		// 					clubFixedPriceStart: null,
		// 					clubFixedPriceEnd: null,
		// 				}
		// 			);
		// 		}
		// 	});
		// }).then(() => {
		// 	dispensePricing.table.forEach((row: any) => {
		// 		selectedMasterProducts = selectedMasterProducts.filter((item: any) => item.productID !== row.productID);
		// 	});
		// 	selectedMasterProducts.forEach((row: any) => currentStock.push(row));
		// 	dispatch(updateDispensePrincingField({ key: "table", value: currentStock }));
		// 	dispatch(updateProductField({ key: "selectedRows", value: [] }));
		// 	dispatch(updateDispensePrincingField({ key: "masterStockPopup", value: false }));
		// });
	}

	const tableRef = useRef<TableRef>(null);

	return (
		<>
			<Title pageTitle={isNewDispensePricing ? "New Special Pricing" : "Update Special Pricing"} crumbs={[{ name: "Special Pricing", path: "/app/dispense-pricing" }]} />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<Col>
									<Row>
										<h4 className="mt-2">{dispensePricing.storeName}</h4>
									</Row>
									<Row>
										<Modal
											title="Confirm"
											show={showWarning}
											buttonType="primary"
											buttonText="Continue"
											buttonCloseText="Cancel"
											handleSubmit={handleSubmit}
											handleClose={() => setShowWarning(false)}
											description={
												<>
													<p>You are about to sync <b>Selected</b> special pricings down to the selected store(s).</p>
													<p>Are you sure you want to continue?</p>
												</>
											}
										/>
									</Row>
									<Row>
										<Col xs={12}>
											<ImportWizard
												title="Special Pricing"
												display={dispensePricing.importWizardPopup}
												handleClose={() => {
													if (terminateWorkersRef.current) terminateWorkersRef.current();
													handleChange("importWizardPopup", false);
												}}
												importAsync={(i) => importStock(i)}
												customColumns={importWizardExtraMatches}
												apnColumn={{
													defaultColumn: 13,
													display: false,
												}}
												pdeColumn={{
													defaultColumn: 14,
													display: false,
												}}
												supplierColumn={{
													defaultColumn: 15,
													display: false,
												}}
												matchAgainst="Products"
												validateTable={(rows) => WholeTableValidation(rows)}
												finish={() => handleChange("importWizardPopup", false)}
												importPercentage={importPercentage}
											/>

											{/* <DispensePricingImport show={dispensePricing.importWizardPopup} handleClose={() => handleChange("importWizardPopup", false)} stores={newStores} /> */}
											<StockPopup show={dispensePricing.stockPopup} handleSave={(stockChanged: boolean) => {
												if (stockChanged) {
													console.log("Stock has been changed! Setting selected stocks to: ", [...dispensePricing.selectedStocks, dispensePricing.stockIndex].filter(onlyUnique));
													// If the stock has been changed, then we need to select this stock in the table
													tableRef.current?.selectRow(dispensePricing.stockIndex.toString());
												}
												handleChange("stockPopup", false);
											}} handleClose={() => handleChange("stockPopup", false)} />
											{/* <SystemStocksPopup show={dispensePricing.masterStockPopup} onClose={() => handleChange("masterStockPopup", false)} onSave={systemStocksPopupSave} canSelectAll={true} /> */}
											<Table
												ref={tableRef}
												disableExport
												pageSize={100}
												isSortable={true}
												pagination={true}
												isSelectable={true}
												isSearchable={true}
												disableAutoSelectReset={dispensePricing.disableAutoSelectReset}
												columns={columns}
												data={dispensePricing.table}
												errors={dispensePricing.error}
												selectedRows={selectedStocks}
												topbarChild={<TopbarChild />}
												loading={dispensePricing.loading}
												reloadTableRows={() => { deletedIds.current = []; dispensePricingId != null && dispatch(getDispensePricing({ stores: [parseInt(dispensePricingId)] })); }}

												singleImport={user.permissions.dispensePricing.canImport ? () => handleChange("importWizardPopup", true) : undefined}
												//addNewRow={user.permissions.dispensePricing.canCreate ? () => handleChange("masterStockPopup", true): undefined}
												removeRows={user.permissions.dispensePricing.canUpdate ? handleDelete : undefined}
											/>
										</Col>
									</Row>
									<Row className="mt-3">
										<Col sm={6}>
											<Link to="/app/dispense-pricing" className="btn text-muted d-none d-sm-inline-block btn-link fw-semibold">
												<i className="mdi mdi-arrow-left"></i> Back to All Special Pricing {" "}
											</Link>
										</Col>
										<Col sm={6} className="d-flex flex-row-reverse">
											<Button variant="primary" className="btn cta-button" disabled={!user.permissions.dispensePricing.canUpdate || dispensePricing.loading} onClick={() => setShowWarning(true)}>
												{dispensePricing.loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
												{dispensePricing.loading ? <>Saving...</> : <>Save</>}
											</Button>
										</Col>
									</Row>
									<Form onSubmit={handleSubmit} validated={isValidated} ref={form}>
									</Form>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}